import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

const FONT = "'Inria Serif', serif";
const DANGER = '#E53935';
const DANGER_SURFACE = 'rgba(229, 57, 53, 0.10)';
const DANGER_BORDER = 'rgba(229, 57, 53, 0.28)';
const SUCCESS = '#1F8E2A';
const SUCCESS_SURFACE = 'rgba(31, 142, 42, 0.10)';
const SUCCESS_BORDER = 'rgba(31, 142, 42, 0.26)';

/**
 * Inline status pill for a required onboarding step. The parent
 * controls `complete` with its live local state (not a fetched copy),
 * so the pill flips green/red the moment the step passes or fails —
 * matching the top-level "Action needed" banner on `VenueSettingsPage`.
 *
 * - complete=true  → green "Everything looks good" pill
 * - complete=false → red "Missing <X>" pill
 */
export function SettingStatusPill({ complete, missingText, testId }) {
  const color = complete ? SUCCESS : DANGER;
  const bg = complete ? SUCCESS_SURFACE : DANGER_SURFACE;
  const border = complete ? SUCCESS_BORDER : DANGER_BORDER;
  const Icon = complete ? CheckCircle2 : AlertTriangle;
  const label = complete ? 'Everything looks good' : missingText;
  if (!label) return null;
  return (
    <span
      data-testid={testId}
      data-complete={complete ? 'true' : 'false'}
      role="status"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: '7px 14px 7px 11px',
        borderRadius: 999,
        background: bg,
        border: `1px solid ${border}`,
        color,
        fontFamily: FONT,
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon size={14} strokeWidth={2.4} />
      {label}
    </span>
  );
}

export default SettingStatusPill;
